import { render, staticRenderFns } from "./BtnExcluirRecurso.vue?vue&type=template&id=e23e7b52"
import script from "./BtnExcluirRecurso.vue?vue&type=script&lang=js"
export * from "./BtnExcluirRecurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports